import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React, { useState } from 'react';
import { ScrollView } from 'react-native';
import { SafeAreaWrapper } from '@/components/SafeAreaWrapper';
import ChallengeUpcomingBottomSheet from './ChallengeUpcomingBottomSheet';
import ChallengeSection from './sections/ChallengeSection';
const ChallengeScreen = () => {
    const [selectedUpcomingChallenge, setSelectedUpcomingChallenge] = useState();
    return (_jsxs(ScrollView, { style: { backgroundColor: 'white' }, children: [_jsx(SafeAreaWrapper, { edges: ['top'], children: _jsx(ChallengeSection, { onPressUpcomingChallenge: challenge => {
                        setSelectedUpcomingChallenge(challenge);
                    } }) }), _jsx(ChallengeUpcomingBottomSheet, { selectedUpcomingChallenge: selectedUpcomingChallenge, onPressConfirmButton: () => {
                    setSelectedUpcomingChallenge(undefined);
                } })] }));
};
export default ChallengeScreen;
